// extracted by mini-css-extract-plugin
export default {"message":"mailbox_message__74vXs"};